import { enumFiltroTipoList } from '@common/util/defaultValues';
const inicialState = {
  pendentesDeRevisaoCount: 0,
  revisadosConcluidosCount: 0,
  periodoInicial: null,
  periodoFinal: null,
  listaKanbam: [],
  medicos: [],
  medicoSelecionado: null,
  tiposExame: [],
  tipoFiltro: 'dtEntregra',
  tipoFiltroValue: '',
  tipoFiltroSelecionado: enumFiltroTipoList.find(x => x.value === 'dtEntregra'),
  optionsFiltroInputTypeSelect: [],
  optionFiltroInputTypeSelectSelecionada: null,
  preview: false,
  laudo: null,
  isFirstLoad: true,
  ordenacao: ''
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.state.js